export const SERVER_URL = '//pxcom.media/simulation/'

export const API_URL = SERVER_URL + 'api'

export const ENTITIES = {
  LOCALBUSINESS: 'localbusiness',
  INTERNATIONAL: 'internationalbusiness',
  AGENCY: 'agency'
}

export default {
  SERVER_URL,
  API_URL
}
